import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change, scroll to top by default — and if there's a hash,
 * scroll to that element once it's mounted.
 */
export const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Small delay so target sections have rendered
      const tries = [50, 200, 500];
      tries.forEach((t) => {
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, t);
      });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
